import { Button } from "antd";
import React from "react";
import { IoAddOutline } from "react-icons/io5";

const RoundButtonWithIcon = ({
  text,
  icon: Icon,
  onClick,
  color = "#8e44ad",
  textColor = "#fff",
  backgroundColor = "transparent",
}) => {
  return (
    <Button
      type="default"
      shape="round"
      icon={<Icon style={{ marginRight: "8px" }} />}
      style={{
        borderColor: color,
        backgroundColor: backgroundColor,
        padding: "6px 16px",
        borderRadius: "12px",
        boxShadow: "none",
        fontSize: "14px",
        color: textColor,
      }}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

const ButtonWithIcon = ({ text, icon: Icon, onClick, color }) => {
  return (
    <Button
      type="primary"
      icon={<Icon style={{ marginRight: "8px" }} />}
      style={{
        backgroundColor: color,
        padding: "6px 16px",
        boxShadow: "none",
        fontSize: "14px",
      }}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};

const AddButtonWithIcon = ({
  text,
  onClick,
  type = "default",
  isTextHiddenOnMobile = false,
}) => {
  return (
    <Button
      type={type}
      icon={
        <IoAddOutline
          className={`${
            isTextHiddenOnMobile ? "text-3xl sm:text-xl mt-2" : "text-base"
          }`}
        />
      }
      onClick={onClick}
      className={`flex items-center justify-center 
        ${
          isTextHiddenOnMobile
            ? "p-0 w-12 h-12 rounded-full text-3xl sm:w-auto sm:h-auto sm:rounded-[12px] sm:px-3 sm:py-1"
            : "px-4 py-2 rounded-[12px] sm:w-auto sm:h-auto"
        } 
        mx-auto`}
      style={{
        backgroundColor: "#2875ce",
        boxShadow: "none",
        fontSize: "16px",
      }}
    >
      {isTextHiddenOnMobile ? (
        <span className="hidden sm:inline">{text}</span>
      ) : (
        text
      )}
    </Button>
  );
};

const AuthActionButton = ({
  text,
  onClick,
  htmlType = "submit", // <-- This is for form submit
  type = "primary",     // <-- This is AntD visual style
}) => {
  return (
    <Button
      type={type}
      htmlType={htmlType}
      onClick={onClick}
      style={{
        background: "linear-gradient(135deg, #ff5f6d, #8e44ad)",
        color: "#fff",
        border: "none",
        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {text}
    </Button>
  );
};
export {
  RoundButtonWithIcon,
  AddButtonWithIcon,
  ButtonWithIcon,
  AuthActionButton,
};
